var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCardsGrey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 38,
    viewBox: "0 0 56 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.7676 8.10099L18.9001 24.7677M35.2238 23.0412L28.0069 27.2078M17.4001 22.1696L23.7334 33.1392C24.6668 34.756 25.1335 35.5643 25.8047 36.0002C26.3951 36.3836 27.0916 36.5702 27.7946 36.5334C28.5938 36.4915 29.4021 36.0248 31.0189 35.0914L50.6488 23.758C52.2655 22.8246 53.0739 22.3579 53.5097 21.6868C53.8931 21.0964 54.0798 20.3998 54.0429 19.6968C54.001 18.8977 53.5343 18.0893 52.6009 16.4726L46.2676 5.50292C45.3342 3.88619 44.8675 3.07782 44.1963 2.64196C43.6059 2.25858 42.9093 2.07193 42.2064 2.10877C41.4072 2.15065 40.5988 2.61736 38.9821 3.55078L19.3522 14.8841C17.7355 15.8175 16.9271 16.2842 16.4912 16.9554C16.1079 17.5458 15.9212 18.2424 15.9581 18.9453C15.9999 19.7445 16.4666 20.5529 17.4001 22.1696Z",
    stroke: "#545454",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6663 15.9857H1.33301M12.333 22.6523H7.99967M15.333 30.9857L6.66634 30.9857C4.7995 30.9857 3.86608 30.9857 3.15304 30.6224C2.52583 30.3028 2.0159 29.7929 1.69632 29.1656C1.33301 28.4526 1.33301 27.5192 1.33301 25.6523L1.33301 12.9857C1.33301 11.1188 1.33301 10.1854 1.69632 9.47238C2.0159 8.84517 2.52583 8.33523 3.15304 8.01566C3.86608 7.65234 4.7995 7.65234 6.66634 7.65234L18.333 7.65235",
    stroke: "#545454",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCardsGrey);
export default __webpack_public_path__ + "static/media/iconCardsGrey.1de500f58f312d88309ec38e248b3b1f.svg";
export { ForwardRef as ReactComponent };